import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
import * as Storage from "../../common/config/Storage";

export class InvoiceViewModel extends BaseViewModel {
  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getInvoices = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var invoiceResponse = await this.getInvoiceListByCodeTag();
    if (
      Format.isNotNull(invoiceResponse.errorCode) &&
      invoiceResponse.errorCode === 0
    ) {
      if (Format.isNotNull(invoiceResponse.invoiceList)) {
        this.updateState("invoiceList", invoiceResponse.invoiceList);
        this.logger.info(invoiceResponse.invoiceList);
      } else {
        this.showEmpty("Invoice");
      }
    } else {
      this.showError("Invoice", CrudlStatus.LIST);
    }
  };

  getInvoicesReturned = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var invoiceResponse = await this.getInvoiceListByCodeTag();
    if (
      Format.isNotNull(invoiceResponse.errorCode) &&
      invoiceResponse.errorCode === 0
    ) {
      if (Format.isNotNull(invoiceResponse.invoiceList)) {
        this.logger.info(invoiceResponse.invoiceList);
        return invoiceResponse.invoiceList;
      } else {
        this.showEmpty("Invoice");
      }
    } else {
      this.showError("Invoice", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (
    invoices,
    apiResponse,
    type,
    externalStateValues
  ) => {
    var updatedInvoiceList = [];
    if (type === CrudlStatus.CREATE) {
      updatedInvoiceList = this.reloadAfterCreate(
        invoices,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedInvoiceList = this.reloadAfterUpdate(
        invoices,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedInvoiceList = this.reloadAfterDelete(
        invoices,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("invoiceList", updatedInvoiceList);
  };

  reloadAfterCreate = (invoiceList, apiResponse, externalStateValues) => {
    if (invoiceList === undefined || invoiceList === null) {
      invoiceList = [];
    }
    var invoiceBean = externalStateValues.invoiceBean;
    invoiceBean.id = apiResponse.id;
    invoiceBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    invoiceList.push(invoiceBean);

    return invoiceList;
  };

  reloadAfterUpdate = (invoiceList, apiResponse, externalStateValues) => {
    var i = 0;
    invoiceList.forEach(e => {
      if (apiResponse.id === e.id) {
        invoiceList[i] = externalStateValues.invoiceBean;
        invoiceList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return invoiceList;
  };

  reloadAfterDelete = (invoiceList, apiResponse, externalStateValues) => {
    var i = 0;
    invoiceList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        invoiceList.splice(i, 1);
      }
      i++;
    });

    return invoiceList;
  };

  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    let invoiceRequest = CloudService.InvoiceRequest.constructFromObject(
      stateVariables.invoiceBean
    );
    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createInvoice(invoiceRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updateInvoice(invoiceRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deleteInvoice(invoiceRequest);
    }
  };

  createInvoice = async (invoiceRequest, stateVariables) => {
    invoiceRequest.codeTag = this.codeTag;
    invoiceRequest.userId = this.userId;

    let invoiceResponse = await ApiService.invoiceCreate(invoiceRequest);
    if (invoiceResponse.errorCode === 0) {
      this.showSuccess("Invoice", CrudlStatus.CREATE);
    } else {
      this.showError("Invoice", CrudlStatus.CREATE);
    }

    return invoiceResponse;
  };

  deleteInvoice = async invoiceRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    request.id = invoiceRequest.id;
    request.lastUpdatedDateTime = invoiceRequest.lastUpdatedDateTime;

    let invoiceResponse = await ApiService.invoiceDelete(request);
    if (invoiceResponse.errorCode === 0) {
      this.showSuccess("Invoice", CrudlStatus.DELETE);
    } else {
      this.showError("Invoice", CrudlStatus.DELETE);
    }

    return invoiceResponse;
  };

  updateInvoice = async (invoiceRequest, stateVariables) => {
    invoiceRequest.codeTag = this.codeTag;
    invoiceRequest.userId = this.userId;

    let invoiceResponse = await ApiService.invoiceUpdate(invoiceRequest);
    if (invoiceResponse.errorCode === 0) {
      this.showSuccess("Invoice", CrudlStatus.UPDATE);
    } else {
      this.showError("Invoice", CrudlStatus.UPDATE);
    }

    return invoiceResponse;
  };
}



// WEBPACK FOOTER //
// ./src/components/Invoice/InvoiceViewModel.js